<template>
  <div>
    <h1>Expedition Monitoring</h1>
    <hr>

    <!-- FILTER STARTS -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
      </template>

      <div class="row">
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">Type</label>
                <MultiSelect 
                    v-model="filter.type"
                    class="mt-1"
                    :options="options.type.map(x => x.value)"
                    :custom-label="opt => options.type.find(x => x.value == opt).label"
                    :allowEmpty="false"
                ></MultiSelect>
            </div>
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">From</label>
                <MultiSelect
                    v-if="filter.type == 'AHMTOMD'" 
                    v-model="filter.from"
                    class="mt-1"
                    :options="['AHM']"
                    :multiple="false"
                    :close-on-select="true"
                    :allowEmpty="false"
                    :disabled="true"
                ></MultiSelect>

                <MultiSelect
                    v-else
                    v-model="filter.from"
                    class="mt-1"
                    :options="options.gudang.map(x => x.code)"

                    :custom-label="opt => options.gudang.find(x => x.code == opt).name ? options.gudang.find(x => x.code == opt).name : opt"
                    :multiple="false"
                    :close-on-select="true"
                    :allowEmpty="true"
                ></MultiSelect>
            </div>
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">To</label>
                <MultiSelect
                    v-if="filter.type == 'AHMTOMD'" 
                    v-model="filter.to"
                    class="mt-1"
                    :options="options.gudang.map(x => x.code)"
                    :custom-label="opt => options.gudang.find(x => x.code == opt).name"
                    :multiple="false"
                    :close-on-select="true"
                    :allowEmpty="true"
                ></MultiSelect>

                <MultiSelect
                    v-else
                    v-model="filter.to"
                    class="mt-1"
                    :options="options.dealer.map(x => x.code)"
                    :custom-label="opt => options.dealer.find(x => x.code == opt).name"
                    :multiple="false"
                    :close-on-select="true"
                    :allowEmpty="true"
                ></MultiSelect>
            </div>
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">Transporter</label>
                <MultiSelect 
                    v-model="filter.transporter"
                    class="mt-1"
                    :options="options.transporter"
                    :multiple="false"
                    :close-on-select="true"
                ></MultiSelect>
            </div>
            <div class="col-12 col-md-4 mt-1">
                <label for="partshopCode">License Plate</label>
                <input 
                    type="text" 
                    v-model="filter.nopol" 
                    class="form-control"
                    placeholder="Search License Plate"
                    style="margin-top:4px;min-height:40px"
                />
            </div>
            
            <div class="col-12 col-md-4 mt-3">
                <button
                    class="btn btn-primary w-100"
                    style="min-height:40px;margin-top:18px;background-color:#FF9700;border : 0"
                    @click="vue_universal_table.update++"
                > Search</button>
            </div>
        </div>
    </panel>
    <!-- FILTER ENDS -->

    <!-- Expedition Start -->
    <div class="innerBox mt-4">
        <div class="row ">
            <div class="col-md-10 Aligner-Header">
                <h4>Expedition Details</h4>
            </div>
            <div class="col-md-2 highlightFilter">
                <button
                    type="button"
                    class="mt-1 btn btn-warning w-100"
                    style="height:90%"
                    @click="fetchDownloadCsv()"
                >Download CSV <i class="fas fa-download"></i></button>
            </div>
        </div>

        <vue-universal-table
            api_url="/api/h1/expedition-monitoring"
            :filter="filter"
            :fields="vue_universal_table.fields"
            :update="vue_universal_table.update"
            sort_by="tgl_kirim"
            sort_order="DESC"
        ></vue-universal-table>
    </div>
    <!-- Expedition End -->
  </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect'

//   import leadTimeDeliveryChart from './children/leadTimeDeliveryChart'
    import flatPickr from 'vue-flatpickr-component'
    const XLSX = require('xlsx')
    import qs from 'qs'

    export default {
        data () {
            return {
                options : {
                    gudang : this.$store.getters.getGudang(),
                    dealer : this.$store.getters.getDealer(),
                    transporter : this.$store.getters.getTransporter,
                    type : [
                        {
                            label : 'AHM to MD',
                            value : 'AHMTOMD'
                        },
                        {
                            label : 'MD to D',
                            value : 'MDTOD'
                        }
                    ]
                },
                filter : {
                    type : 'AHMTOMD',
                    from : 'AHM',
                    to : null,
                    transporter : null,
                    nopol : null
                },
                vue_universal_table : {
                    fields : [
                        {title:"License Plate", variable:"nopol"},
                        {title:"Carried Quantity", variable:"jumlah"},
                        {title:"From", variable:"asal"},
                        {title:"To", variable:"tujuan"},
                        {title:"Depart Date", variable:"tgl_kirim", date_format:"DD MMM YYYY HH:mm:ss"},
                        {title:"Transporter", variable:"ekspedisi"}
                    ],
                    update: 0,
                },
            }
        },
        watch : {
            'filter.type' : function() {
                if(this.filter.type == 'AHMTOMD') {
                    this.filter.from = 'AHM'
                    this.filter.to = null
                } else {
                    this.filter.from = null
                    this.filter.to = null
                }
            }
        },
        components : {
            MultiSelect,
            flatPickr
        //   leadTimeDeliveryChart,
        },
        mounted () {

        },
        methods : {
            setFilterUrl(a){
                this.filterUrl = a
            },
            fetchDownloadCsv () {
                this.$http.get(`/api/h1/expedition-monitoring?pagination=false&${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.exportCsv(resp.data.data, "Expedition Monitoring");
                })
                .catch((err)=>{console.log(err)})
            }
        }
    }
</script>

<style scoped>
  
</style>